<template>
  <v-select
    v-model="selectedRole"
    :items="roles"
    :loading="loading"
    :label="label"
    :hint="hint"
    :persistent-hint="!!hint"
    :disabled="disabled"
    item-text="localizedDescription"
    item-value="_id"
    outlined
    :dense="dense"
    @change="onChange"
  >
    <template #item="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.localizedDescription }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import AuthorRolesMixin from '@/mixins/AuthorRolesMixin';

export default {
  name: 'AuthorRoleSelector',
  mixins: [AuthorRolesMixin],
  props: {
    value: {
      type: String,
      default: 'author'
    },
    label: {
      type: String,
      default: 'Role'
    },
    hint: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedRole: this.value,
      roles: [],
      loading: false
    };
  },
  watch: {
    value(newValue) {
      this.selectedRole = newValue;
    }
  },
  async created() {
    this.loading = true;
    this.roles = await this.fetchAuthorRoles();
    this.loading = false;
  },
  methods: {
    onChange() {
      this.$emit('input', this.selectedRole);
      
      // Find the selected role object
      const roleObj = this.roles.find(role => role._id === this.selectedRole);
      if (roleObj) {
        this.$emit('role-selected', {
          id: roleObj.id,
          _id: roleObj._id,
          description: roleObj.description,
          localizedDescription: roleObj.localizedDescription
        });
      }
    }
  }
};
</script>
